import { render } from "./SeoProgress.vue?vue&type=template&id=5631bd92&scoped=true"
import script from "./SeoProgress.vue?vue&type=script&lang=js"
export * from "./SeoProgress.vue?vue&type=script&lang=js"

import "./SeoProgress.vue?vue&type=style&index=0&id=5631bd92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5631bd92"]])

export default __exports__